import { gql } from "@apollo/client";

export const AssetAssetLocation = gql`
    query AssetAssetLocation ($id: ID!) {
        assetLocation (id: $id) {
            id
            asset {
                id
            }
            iotConnection {
                id
            }
            installedBaseNode {
                id
                isStarred
            }
        }
    }
`;
